<template>
  <div class="login-form">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item prop="mobile" class="form-item">
        <div class="input-wrapper">
          <div class="input-icon">
            <i class="el-icon-mobile-phone"></i>
          </div>
          <el-input placeholder="请输入手机号" clearable maxLength="11" v-model.trim="form.mobile" @keyup.enter.native="login"></el-input>
        </div>
      </el-form-item>
      <el-form-item prop="vcode" class="form-item">
        <div class="code-input-container">
          <div class="input-wrapper">
            <div class="input-icon">
              <i class="el-icon-message"></i>
            </div>
            <el-input placeholder="请输入验证码" clearable maxLength="6" v-model.trim="form.vcode" @keyup.enter.native="login">
              <el-button slot="append"  @click="getCode" :disabled="disabled">{{btnTxt}}</el-button>
            </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="form-item checkbox-item">
        <div class="checkbox-wrapper">
          <el-checkbox v-model="remember">
            <span class="checkbox-label">记住手机号</span>
          </el-checkbox>
        </div>
      </el-form-item>
    </el-form>
    <el-button type="primary" class="login-btn" @click="login">
      <span class="btn-text">立即登录</span>
    </el-button>
  </div>
</template>

<script>
import {inputEmpty} from "@utils/validate";
import {Base64} from "js-base64";

export default {
  name: "SmsLogin",
  data() {
    return {
      remember: false,
      form: {
        mobile: process.env.NODE_ENV === "production" ? "" : "13438323907",
        vcode: process.env.NODE_ENV === "production" ? "" : "",
      },
      rules: {
        mobile: [inputEmpty("手机号")],
        vcode: [inputEmpty("短信验证码")],
      },
      // 验证码
      disabled: false,
      time: 0,
      btnTxt: "获取验证码",
      timer: null,
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  created() {
    const loginMobile = localStorage.getItem("loginMobile");
    if (loginMobile) {
      this.form.mobile = Base64.decode(loginMobile);
      this.remember = true;
    }
  },
  methods: {
    //获取手机验证码
    async getCode() {
      let mobile = this.form.mobile;
      this.$refs["form"].validateField("mobile", async error => {
        if (!error) {
          let res = await this.$Http.sendSms({type: 'admin_login', mobile});
          if (res) {
            this.form.vcode = res.data || "";
            this.msgSuccess("发送成功");
            this.time = 60;
            this.disabled = true;
            this.timerCount();
          }
        }
      });
    },
    timerCount() {
      if (this.time > 0) {
        this.time--;
        this.btnTxt = "请稍等(" + this.time + "s)";
        this.timer = setTimeout(this.timerCount, 1000);
      } else {
        this.time = 0;
        this.btnTxt = "获取验证码";
        this.disabled = false;
      }
    },
    login() {
      this.$refs['form'].validate(async isOk => {
        if (isOk) {
          let nv = {...this.form};
          let res = await this.$Http.smsLogin(nv);
          if (res?.data) {
            if (this.remember) {
              localStorage.setItem("loginMobile", Base64.encode(nv.mobile));
            } else {
              localStorage.removeItem("loginMobile");
            }
            this.$emit("finish", res.data)
          }
        }
      })
    },
  },
}
</script>



<style scoped>

</style>